export default __webpack_public_path__ + "static/wstETH-3d539a2e2386b7bef085b4fe36e707f4.svg";